/* LC JP Phase1 (2026-10-20) — 送料無料バー（商品ページの同期）+ カート追加提案のワンタップ追加.
   Loaded (defer) by snippets/lc-free-shipping-bar.liquid and snippets/lc-cart-addon.liquid; runs once per page.
   The drawer and the cart page re-render #AjaxCartForm from ?section_id=helper-cart after every cart change
   (theme component-cart.js / component-product-form.js), so their bars are always server-rendered.
   The product-page bar sits outside #AjaxCartForm: after each re-render we copy the drawer bar's markup into it,
   so both come from the same Liquid snippet and can never disagree. */
(function () {
  if (window.LCCartBoost) return;
  window.LCCartBoost = { version: '2026-10-20' };

  function syncPdpBars() {
    var src = document.querySelector('#AjaxCartForm [data-lc-fsb]');
    var srcBody = src && src.querySelector('[data-lc-fsb-body]');
    if (!srcBody) return;
    document.querySelectorAll('[data-lc-fsb="pdp"]').forEach(function (dst) {
      var body = dst.querySelector('[data-lc-fsb-body]');
      if (body) body.innerHTML = srcBody.innerHTML;
      dst.classList.toggle('is-done', src.classList.contains('is-done'));
    });
  }

  function watchCart() {
    var form = document.getElementById('AjaxCartForm');
    if (!form || !document.querySelector('[data-lc-fsb="pdp"]')) return;
    new MutationObserver(syncPdpBars).observe(form, { childList: true });
  }

  function addToCart(btn) {
    var box = btn.closest('[data-lc-addon]');
    var err = box && box.querySelector('[data-lc-addon-error]');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-busy') || label;
    if (err) err.hidden = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart') || typeof window.refreshCart !== 'function') {
          window.location.reload();
          return;
        }
        window.refreshCart();   // theme helper: re-renders #AjaxCartForm + subtotal, updates the header count
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (err) err.hidden = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-lc-addon-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
